import isNil from 'lodash/fp/isNil';
import type { MapPointData } from '../../../common/types';
import { coordinatesToString } from '../../../common/utils';
import { store } from '../../../configuration/setup/store';
import { trace } from '../../../configuration/setup/trace';
import { resolveAddress } from '../../../features/fetchData/resolveAddress';
import { selectOrderedWaypoints, selectWaypoints } from '../../search/searchSelectors';
import { type Waypoint, WaypointType, waypointAdded, waypointChanged } from '../../search/searchSlice';
import { addStationWaypointHandler } from './addStationWaypoint';

export const SET_ROUTING_STOPOVER_POINT = 'EVENT_SET_ROUTING_STOPOVER_POINT';
export const CS_MARKER_TYPE = 'chargingStation';

export const setRoutingStopoverPointHandler = async (event: MessageEvent, mapPointData: MapPointData) => {
    try {
        if (mapPointData.markerType === CS_MARKER_TYPE) {
            addStationWaypointHandler(mapPointData);
            return;
        }
        const resolvedAddress = await store.dispatch(resolveAddress(event));
        const waypoints = selectWaypoints(store.getState());
        const orderedWaypoints = selectOrderedWaypoints(store.getState());
        const lastWaypoint = orderedWaypoints.at(-1);
        const isWaypointDuplicated = waypoints.some(wp => wp.addressLabel === resolvedAddress);
        if (!isWaypointDuplicated) {
            store.dispatch(waypointAdded(-1));
            store.dispatch(
                waypointChanged({
                    id: store.getState().search.waypointsOrder.at(-2),
                    addressLabel: isNil(resolvedAddress)
                        ? coordinatesToString(mapPointData.coordinates)
                        : resolvedAddress,
                    coordinates: mapPointData.coordinates,
                    type: WaypointType.ADDITIONAL_STOP,
                } as Waypoint)
            );

            if (lastWaypoint) {
                store.dispatch(
                    waypointChanged({
                        id: store.getState().search.waypointsOrder.at(-1),
                        addressLabel: lastWaypoint.addressLabel,
                        coordinates: lastWaypoint.coordinates,
                        type: lastWaypoint.type,
                    } as Waypoint)
                );
            }
        }
    } catch (e) {
        trace.error(e);
    }
};
